import { render } from "./RecordBookArchiveItems.vue?vue&type=template&id=489eb96c&lang=pug"
import script from "./RecordBookArchiveItems.vue?vue&type=script&lang=js"
export * from "./RecordBookArchiveItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__